module.exports = __webpack_public_path__ + "img/peixun.7923458c.jpg";